import { useEffect, useState } from 'react';
import { getPartner } from './fluxes';

const campaignsConfig = (campaigns, makeConfig) =>
  campaigns.reduce(
    (config, campaign) => ({
      ...config,
      [campaign]: makeConfig(campaign),
    }),
    {},
  );

const isUs = window.location.pathname.startsWith('/us/');
const defaultConfig = {
  title: '123Seguro',
  description:
    'En 123Seguro vas a poder encontrar una gran variedad de seguros para autos y contratar el que mejor se adapte a tus necesidades. ¡Cotizá tu seguro online!',
  image: 'https://branding.123seguro.com/logotypes/123/color/logo_123seguro.svg',
  favicons: {
    favicon16: '/wizard/favicon-16x16.png',
    favicon32: '/wizard/favicon-32x32.png',
    favicon152: '/wizard/apple-touch-icon.png',
    favicon180: '/wizard/apple-touch-icon.png',
    faviconIco: '/wizard/favicon.ico',
  },
  manifest: '/wizard/site.webmanifest',
  ...(isUs
    ? {
        title: 'Protect and prepare your loved ones | Prudential',
        image: 'https://branding.123seguro.com/favicons/prudential.png',
        favicons: {
          favicon16: 'https://branding.123seguro.com/favicons/prudential-16x16.png',
          favicon32: 'https://branding.123seguro.com/favicons/prudential-32x32.png',
          favicon152: 'https://branding.123seguro.com/favicons/prudential-152x152.png',
          favicon180: 'https://branding.123seguro.com/favicons/prudential-180x180.png',
          faviconIco: 'https://branding.123seguro.com/favicons/prudential.ico',
        },
      }
    : {}),
};

const partnerSEOConfig = {
  serasa: {
    title: 'Segurança, tranquilidade e proteção para você em todos os momentos!',
    description:
      'Seguro Acidentes Pessoais. Uma parceria entre Serasa e Prudential que busca proteger nosso maior bem, que é você.',
    image: 'https://branding.123seguro.com/favicons/prudential.png',
    favicons: {
      favicon16: 'https://branding.123seguro.com/favicons/prudential-16x16.png',
      favicon32: 'https://branding.123seguro.com/favicons/prudential-32x32.png',
      favicon152: 'https://branding.123seguro.com/favicons/prudential-152x152.png',
      favicon180: 'https://branding.123seguro.com/favicons/prudential-180x180.png',
      faviconIco: 'https://branding.123seguro.com/favicons/prudential.ico',
    },
    manifest: 'https://www.prudentialparceiros.com.br/site.webmanifest',
  },
  liverpool: {
    title: 'Seguridad, tranquilidad y protección para tí en todo momento',
    description: 'Seguro de accidentes personales',
    image: 'https://branding.123seguro.com/favicons/prudential.png',
    favicons: {
      favicon16: 'https://branding.123seguro.com/favicons/prudential-16x16.png',
      favicon32: 'https://branding.123seguro.com/favicons/prudential-32x32.png',
      favicon152: 'https://branding.123seguro.com/favicons/prudential-152x152.png',
      favicon180: 'https://branding.123seguro.com/favicons/prudential-180x180.png',
      faviconIco: 'https://branding.123seguro.com/favicons/prudential.ico',
    },
    manifest: '/site.webmanifest',
  },
  ...campaignsConfig(
    [
      'comafi-emailmkt',
      'comafi-whatsapp',
      'comafi-rrss',
      'comafi-sucursales',
      'comafi-notipush',
      'comafi-web',
    ],
    () => ({
      title: 'Comafi Seguros',
      description:
        '¡Ahorra hasta un 90% en combustible y obtené la 6ª cuota del seguro totalmente gratis!',
      favicons: {
        faviconIco: 'https://branding.123seguro.com/favicons/comafi.ico',
      },
    }),
  ),
  ...campaignsConfig(
    [
      'supervielle-sucursales',
      'supervielle-individual-sucursal',
      'supervielle-remarketing',
      'supervielle-affinity',
      'supervielle-ffvv',
    ],
    () => ({
      title: 'Supervielle Seguros',
      description: 'Contratá tu seguro de forma simple y segura',
      favicons: {
        faviconIco: 'https://branding.123seguro.com/favicons/supervielle.ico',
      },
    }),
  ),
};

export const useSEOConfig = () => {
  const partner = getPartner();

  const [seoConfig, setSeoConfig] = useState(null);

  useEffect(() => {
    setSeoConfig(partnerSEOConfig[partner] || defaultConfig);
  }, [partner]);

  return seoConfig;
};
